// extracted by mini-css-extract-plugin
export default {"inboxcalander":"Navbar_inboxcalander__zE53w","chatIcon":"Navbar_chatIcon__Bs4gs","notification":"Navbar_notification__rIskt","brokerageIcon":"Navbar_brokerageIcon__GEIST"};